export default "__VITE_PUBLIC_ASSET__c04c09dc__"